import { LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';
import React from "react";
const data = [
    {name: 'A', uv: 1, amt: 10},
    {name: 'B', uv: 1, amt: 10},
    {name: 'C', uv: 2, amt: 10},
    {name: 'D', uv: 1, amt: 10},
];

class LPGGraph extends React.Component {
    render() {
        return (
            <LineChart width={160} height={150} data={data}>
                <Line type="monotone" dataKey="uv" stroke="#6684d8" strokeWidth="5"/>
                <CartesianGrid stroke="#ccc" />
                <XAxis label="LPG" dy={50}/>
                <YAxis />
            </LineChart>
        );
    }
}


export default LPGGraph;
